import { useState } from "react";

export default function useUpgradeModal() {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    return { isOpen, setIsOpen }
}